module.exports = __webpack_public_path__ + "static/media/LevelDown.61cf9ec6.svg";